import React, { useState, useEffect } from "react";
import {
  Button,
  Checkbox,
  Container,
  Tab,
  Tabs,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Card,
  CardContent,
  FormControlLabel,
  Grid,
  Paper,
} from "@mui/material";
import axios from "axios"; // Import Axios
import DeleteIcon from "@mui/icons-material/Delete";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DoneIcon from "@mui/icons-material/Done";
import EditIcon from "@mui/icons-material/Edit";
import EditOffIcon from "@mui/icons-material/EditOff";
import { useApplication } from "./IrrigationContext";
import { useApplication1 } from "./SensorContext";
import { getCentralMidnightUTC } from "./timezoneUtils";
import { format, fromZonedTime } from "date-fns-tz";

function CottonIrrigationManagementForm() {
  const [sectionData, setSectionData] = useState("v10-harvest");
  const [date, setDate] = useState("");
  const [error, setError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [formErrorMsg, setFormErrorMsg] = useState("");
  const [formSuccessMsg, setFormSuccessMsg] = useState("");
  const [amount, setAmount] = useState("");
  const [applications, setApplications] = useState([]);
  const teamName = localStorage.getItem("username");
  const sensorOptions = ["BMP logic", "AquaSpy"];
  // const [selectedOption, setSelectedOption] = useState("");
  const token = localStorage.getItem("token");
  const [displayDate, setDisplayDate] = useState("");

  const [dateToday, setDateToday] = useState(getCentralMidnightUTC());

  //const [isApplicationTypeConfirmed, setIsApplicationTypeConfirmed] =useState(false);

  const handleApplicationTypeConfirmation = (event) => {
    setIsApplicationTypeConfirmed(event.target.checked);
  };

  const handleApplicationTypeConfirmation1 = (event) => {
    setIsApplicationTypeConfirmed1(event.target.checked);
  };

  const {
    selectedOption,
    setSelectedOption,
    isApplicationTypeConfirmed,
    setIsApplicationTypeConfirmed,
  } = useApplication();

  const {
    soilMoistureSensor,
    setSoilMoistureSensor,
    isApplicationTypeConfirmed1,
    setIsApplicationTypeConfirmed1,
  } = useApplication1();

  const handleConfirmApplicationType = () => {
    setIsApplicationTypeConfirmed(true);
    saveApplicationTypeConfirmationToBackend();
  };

  const handleConfirmApplicationType1 = () => {
    setIsApplicationTypeConfirmed1(true);
    saveApplicationTypeConfirmationToBackend1();
  };

  const saveApplicationTypeConfirmationToBackend = () => {
    const data = {
      teamName: teamName,
      applicationType: selectedOption,
      optionConfirmed: 1,
    };

    axios
      .post("/api/saveIrrigationApplicationTypeConfirmationCotton", data, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        console.log("Application type confirmation saved:", response);
      })
      .catch((error) => {
        console.error("Error saving application type confirmation:", error);
      });
  };

  const saveApplicationTypeConfirmationToBackend1 = () => {
    const data = {
      teamName: teamName,
      sensorType: soilMoistureSensor,
      sensorConfirmed: 1,
    };
    axios
      .post("/api/saveMoistureApplicationTypeConfirmationCotton", data, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        console.log("Application type confirmation saved:", response);
      })
      .catch((error) => {
        console.error("Error saving application type confirmation:", error);
      });
  };

  useEffect(() => {
    fetchApplicationTypeConfirmation();
    fetchApplicationTypeConfirmation1();
    fetchData();
  }, []); // Fetch data whenever applicationType changes

  const fetchApplicationTypeConfirmation = () => {
    axios
      .get("/api/getIrrigationApplicationTypeConfirmationCotton", {
        params: { teamName: teamName },
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          // Assuming response.data has the structure { applicationType, isConfirmed }
          setSelectedOption(response.data.applicationType);
          // Convert the value to boolean (handles both 1/0 and true/false)
          setIsApplicationTypeConfirmed(Boolean(response.data.optionConfirmed));
        } else {
          console.error("Application type confirmation not found");
        }
      })
      .catch((error) => {
        console.error("Error fetching application type confirmation:", error);
      });
  };

  const fetchApplicationTypeConfirmation1 = () => {
    axios
      .get("/api/getMoistureApplicationTypeConfirmationCotton", {
        params: { teamName: teamName },
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          // Assuming response.data has the structure { applicationType, isConfirmed }
          setSoilMoistureSensor(response.data.sensorType);
          // Convert the value to boolean (handles both 1/0 and true/false)
          setIsApplicationTypeConfirmed1(
            Boolean(response.data.sensorConfirmed),
          );
        } else {
          console.error("Sensor type confirmation not found");
        }
      })
      .catch((error) => {
        console.error("Error fetching sensor type confirmation:", error);
      });
  };

  const amountOptions = [
    "0.05",
    "0.10",
    "0.15",
    "0.20",
    "0.25",
    "0.30",
    "0.35",
    "0.40",
    "0.45",
    "0.50",
  ];

  const handleAmountCardClick = (selectedAmount) => {
    setAmount(selectedAmount);
    setFormSuccessMsg("");
  };

  const handleCardClick = (value) => {
    setSelectedOption(value);
  };

  const handleDeleteApplication = (appId) => {
    axios
      .delete(`/api/deletecottonirrigationApplication/${appId}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Application deleted successfully, now update the table data
          fetchData();
          // Reset form fields to enable immediate re-submission
          setDate("");
          setAmount("");
          setDisplayDate("");
          setFormErrorMsg("");
          setFormSuccessMsg("");
        } else {
          console.error("Failed to delete the application");
        }
      })
      .catch((error) => {
        console.error("Error deleting the application:", error);
      });
  };

  const fetchData = () => {
    axios
      .get("/api/cottonfetchSoilMoistureSensorData", {
        params: {
          teamName, // Replace with the actual team name
        },

        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      }) // Update the URL accordingly
      .then((response) => {
        // Handle the successful response and update the state
        setApplications(response.data);
        console.log(response);
      })
      .catch((error) => {
        // Handle errors
        console.error("Error fetching data:", error);
      });
  };

  // Function to send form data to the backend
  const submitForm = async (e) => {
    e.preventDefault();
    setFormErrorMsg("");
    setFormSuccessMsg("");

    if (!isApplicationTypeConfirmed1) {
      setFormErrorMsg("Please confirm your sensor selection first");
      return;
    }

    if (!isApplicationTypeConfirmed) {
      setFormErrorMsg("Please confirm your irrigation management type first");
      return;
    }

    if (!selectedOption || selectedOption === "") {
      setFormErrorMsg("Please fill in all inputs");
      return;
    }

    if (!soilMoistureSensor || soilMoistureSensor === "") {
      setFormErrorMsg("Please fill in all inputs");
      return;
    }

    if (!date || date === "") {
      setFormErrorMsg("Please fill in all inputs");
      return;
    }

    if (!amount || amount === "") {
      setFormErrorMsg("Please fill in all inputs");
      return;
    }

    // Prepare the data to be sent
    const formData = {
      date: date,
      reading: amount,
      options: selectedOption,
      applied: "no",
      teamName,
      sensorType: soilMoistureSensor, // always include
      dateToday: dateToday,
      applicationType: selectedOption,
      sensorConfirmed: isApplicationTypeConfirmed1,
      optionConfirmed: isApplicationTypeConfirmed,
    };

    // Send a POST request to your backend endpoint
    axios
      .post("/api/cottonsoilmoisturesensorsubmit", formData, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      }) // Update the URL accordingly
      .then((response) => {
        // Handle the successful response if needed
        if (response.status === 200) {
          console.log("Application data sent to the backend successfully");
          setAmount("");
          setDate("");
          setDisplayDate("");
          setFormSuccessMsg("Irrigation application submitted successfully.");
          fetchData();
        } else {
          console.error("Failed to send application data to the backend");
        }
      })
      .catch((error) => {
        // Handle errors
        console.error("Error submitting form:", error);
      });
  };

  const handleSensorCardClick = (selectedSensor) => {
    // Handle card click event to select the sensor
    //if (!soilMoistureSensor)
    setSoilMoistureSensor(selectedSensor);
  };

  const usHolidays = [
    "2026-01-01", // New Year's Day
    "2026-07-04", // Independence Day
    "2026-11-11", // Veterans Day
    "2026-12-25", // Christmas Day
  ];

  const getDynamicHolidays = (year) => {
    const holidays = [];

    // Martin Luther King Jr. Day (Third Monday of January)
    // const mlkDay = new Date(year, 0, 1);
    // while (mlkDay.getDay() !== 1) mlkDay.setDate(mlkDay.getDate() + 1);
    // mlkDay.setDate(mlkDay.getDate() + 14); // Third Monday
    // holidays.push(mlkDay.toISOString().split("T")[0]);

    // // Presidents' Day (Third Monday of February)
    // const presidentsDay = new Date(year, 1, 1);
    // while (presidentsDay.getDay() !== 1)
    //   presidentsDay.setDate(presidentsDay.getDate() + 1);
    // presidentsDay.setDate(presidentsDay.getDate() + 14);
    // holidays.push(presidentsDay.toISOString().split("T")[0]);

    // Memorial Day (Last Monday of May)
    // const memorialDay = new Date(year, 4, 31);
    // while (memorialDay.getDay() !== 1)
    //   memorialDay.setDate(memorialDay.getDate() - 1);
    // holidays.push(memorialDay.toISOString().split("T")[0]);

    // Labor Day (First Monday of September)
    // const laborDay = new Date(year, 8, 1);
    // while (laborDay.getDay() !== 1) laborDay.setDate(laborDay.getDate() + 1);
    // holidays.push(laborDay.toISOString().split("T")[0]);

    // // Thanksgiving (Fourth Thursday of November)
    // const thanksgiving = new Date(year, 10, 1);
    // while (thanksgiving.getDay() !== 4)
    //   thanksgiving.setDate(thanksgiving.getDate() + 1);
    // thanksgiving.setDate(thanksgiving.getDate() + 21);
    // holidays.push(thanksgiving.toISOString().split("T")[0]);

    return holidays;
  };

  const handleDateChange = (e) => {
    const selectedDate = e.target.value;
    const dateObj = new Date(selectedDate);
    const dayOfWeek = dateObj.getDay();
    const year = dateObj.getFullYear();

    const allHolidays = [...usHolidays, ...getDynamicHolidays(year)];

    if (dayOfWeek === 5 || dayOfWeek === 6) {
      setError(true);
      setErrorMessage("No Irrigation inputs can be applied on weekends.");
      setDisplayDate("");
      setDate("");
    } else if (allHolidays.includes(selectedDate)) {
      setError(true);
      setErrorMessage(
        "Selected date is a U.S. public holiday. No Irrigation inputs can be applied on public holidays.",
      );
      setDisplayDate("");
      setDate("");
    } else {
      setError(false);
      setErrorMessage("");

      const timeZone = "America/Chicago";
      const localMidnight = new Date(`${selectedDate}T00:00:00`);
      const utcDate = fromZonedTime(localMidnight, timeZone);

      setDisplayDate(selectedDate); // For UI display
      setDate(utcDate.toISOString()); // UTC value for backend
    }
  };

  const formatDateForDisplay = (isoString) => {
    if (!isoString) return "";
    const timeZone = "America/Chicago"; // Jay, FL
    const zoned = fromZonedTime(isoString, timeZone);
    return format(zoned, "MM/dd/yyyy");
  };

  return (
    <Container maxWidth="100%">
      <form onSubmit={submitForm}>
        {/* STEP 1: Sensor Selection First */}
        <Grid item xs={12}>
          <h4>Step 1: Select Your Sensor</h4>
          <Typography
            variant="body1"
            gutterBottom
            style={{ textAlign: "justify" }}
          >
            One soil moisture probe will be installed per-team for soil moisture
            monitoring. Teams will be responsible to communicate the type of
            soil moisture sensor to be installed in their plot at the time of
            planting.
          </Typography>
          <div style={{ display: "flex", flexWrap: "wrap", marginTop: "16px" }}>
            {sensorOptions.map((sensorOption) => (
              <Card
                key={sensorOption}
                onClick={() => {
                  if (isApplicationTypeConfirmed1) return;
                  handleSensorCardClick(sensorOption);
                }}
                sx={{
                  cursor: isApplicationTypeConfirmed1
                    ? "not-allowed"
                    : "pointer",
                  margin: "4px",
                  padding: "10px 16px",
                  backgroundColor:
                    soilMoistureSensor === sensorOption ? "#fa4616" : "#F5F5F5",
                  border:
                    soilMoistureSensor === sensorOption
                      ? "2px solid rgb(255, 255, 255)"
                      : "2px solid rgb(37, 106, 185)",
                  borderRadius: "12px",
                  color: soilMoistureSensor === sensorOption ? "white" : "#333",
                  boxShadow:
                    soilMoistureSensor === sensorOption
                      ? "0px 4px 10px rgba(0, 0, 0, 0.2)"
                      : "none",
                  transition: "all 0.3s ease-in-out",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  width: "200px",
                  height: "50px",
                  pointerEvents: isApplicationTypeConfirmed1 ? "none" : "auto",
                  opacity: isApplicationTypeConfirmed1 ? 0.7 : 1,
                  "&:hover": isApplicationTypeConfirmed1
                    ? {}
                    : {
                        backgroundColor:
                          soilMoistureSensor === sensorOption
                            ? "#d73a12"
                            : "#E0E0E0",
                        transform: "scale(1.02)",
                      },
                }}
              >
                <CardContent>
                  <Typography variant="body2">{sensorOption}</Typography>
                </CardContent>
              </Card>
            ))}
          </div>
          {!isApplicationTypeConfirmed1 && (
            <FormControlLabel
              style={{ marginTop: "16px" }}
              control={
                <Checkbox
                  checked={isApplicationTypeConfirmed1}
                  disabled={!soilMoistureSensor}
                  onChange={(event) => {
                    handleApplicationTypeConfirmation1(event);
                    if (event.target.checked) {
                      handleConfirmApplicationType1();
                    }
                  }}
                />
              }
              label="Confirm Sensor selection by ticking the checkbox (this cannot be changed later once check box is ticked)"
            />
          )}
          {isApplicationTypeConfirmed1 && (
            <Typography
              variant="body1"
              style={{
                marginTop: "16px",
                fontWeight: "bold",
                color: "#fa4616",
              }}
            >
              ✓ Selected Sensor: {soilMoistureSensor}
            </Typography>
          )}

          {soilMoistureSensor && (
            <>
              <p style={{ textAlign: "justify", marginTop: "16px" }}>
                You will have access to soil moisture data on the respective
                company's website.
              </p>
              <ul>
                <li>
                  <p style={{ textAlign: "justify" }}>
                    Select the irrigation amount (depth) in 0.05-inch increments
                    at least one day before the application.
                  </p>
                </li>
                <li>
                  <p style={{ textAlign: "justify" }}>
                    From planting to harvest, the maximum irrigation depth per
                    application is 0.5 inches.
                  </p>
                </li>
                <li>
                  <p style={{ textAlign: "justify" }}>
                    No irrigation will be applied if no selection is made.
                  </p>
                </li>
              </ul>
            </>
          )}
        </Grid>
        <br />

        {/* STEP 2: Irrigation Type Selection - only after sensor is confirmed */}
        {isApplicationTypeConfirmed1 && (
          <>
            <Grid item xs={12}>
              <h4>Step 2: Select Your Irrigation Management Type</h4>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  width: "100%",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                <Card
                  onClick={() => {
                    if (isApplicationTypeConfirmed) return;
                    handleCardClick("soil-moisture");
                  }}
                  sx={{
                    width: { xs: "100%", sm: "48%", md: "30%" },
                    minWidth: { xs: "auto", sm: "200px" },
                    padding: { xs: "8px", sm: "10px 16px" },
                    backgroundColor:
                      selectedOption === "soil-moisture"
                        ? "#fa4616"
                        : "#F5F5F5",
                    border:
                      selectedOption === "soil-moisture"
                        ? "2px solid rgb(255, 255, 255)"
                        : "2px solid rgb(37, 106, 185)",
                    borderRadius: "12px",
                    color:
                      selectedOption === "soil-moisture" ? "white" : "#333",
                    boxShadow:
                      selectedOption === "soil-moisture"
                        ? "0px 4px 10px rgba(0, 0, 0, 0.2)"
                        : "none",
                    transition: "all 0.3s ease-in-out",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    height: "60px",
                    cursor: isApplicationTypeConfirmed
                      ? "not-allowed"
                      : "pointer",
                    pointerEvents: isApplicationTypeConfirmed ? "none" : "auto",
                    opacity: isApplicationTypeConfirmed ? 0.7 : 1,
                    "&:hover": isApplicationTypeConfirmed
                      ? {}
                      : {
                          backgroundColor:
                            selectedOption === "soil-moisture"
                              ? "#d73a12"
                              : "#E0E0E0",
                          transform: "scale(1.02)",
                        },
                  }}
                >
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Soil Moisture-Based
                    </Typography>
                  </CardContent>
                </Card>

                <Card
                  onClick={() => {
                    if (isApplicationTypeConfirmed) return;
                    handleCardClick("evapotranspiration");
                  }}
                  sx={{
                    width: { xs: "100%", sm: "48%", md: "30%" },
                    minWidth: { xs: "auto", sm: "200px" },
                    padding: { xs: "8px", sm: "10px 16px" },
                    backgroundColor:
                      selectedOption === "evapotranspiration"
                        ? "#fa4616"
                        : "#F5F5F5",
                    border:
                      selectedOption === "evapotranspiration"
                        ? "2px solid rgb(255, 255, 255)"
                        : "2px solid rgb(37, 106, 185)",
                    borderRadius: "12px",
                    color:
                      selectedOption === "evapotranspiration"
                        ? "white"
                        : "#333",
                    boxShadow:
                      selectedOption === "evapotranspiration"
                        ? "0px 4px 10px rgba(0, 0, 0, 0.2)"
                        : "none",
                    transition: "all 0.3s ease-in-out",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    height: "60px",
                    cursor: isApplicationTypeConfirmed
                      ? "not-allowed"
                      : "pointer",
                    pointerEvents: isApplicationTypeConfirmed ? "none" : "auto",
                    opacity: isApplicationTypeConfirmed ? 0.7 : 1,
                    "&:hover": isApplicationTypeConfirmed
                      ? {}
                      : {
                          backgroundColor:
                            selectedOption === "evapotranspiration"
                              ? "#d73a12"
                              : "#E0E0E0",
                          transform: "scale(1.02)",
                        },
                  }}
                >
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Evapotranspiration Based
                    </Typography>
                  </CardContent>
                </Card>

                <Card
                  onClick={() => {
                    if (isApplicationTypeConfirmed) return;
                    handleCardClick("calendar");
                  }}
                  sx={{
                    width: { xs: "100%", sm: "48%", md: "30%" },
                    minWidth: { xs: "auto", sm: "200px" },
                    padding: { xs: "8px", sm: "10px 16px" },
                    backgroundColor:
                      selectedOption === "calendar" ? "#fa4616" : "#F5F5F5",
                    border:
                      selectedOption === "calendar"
                        ? "2px solid rgb(255, 255, 255)"
                        : "2px solid rgb(37, 106, 185)",
                    borderRadius: "12px",
                    color: selectedOption === "calendar" ? "white" : "#333",
                    boxShadow:
                      selectedOption === "calendar"
                        ? "0px 4px 10px rgba(0, 0, 0, 0.2)"
                        : "none",
                    transition: "all 0.3s ease-in-out",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    height: "60px",
                    cursor: isApplicationTypeConfirmed
                      ? "not-allowed"
                      : "pointer",
                    pointerEvents: isApplicationTypeConfirmed ? "none" : "auto",
                    opacity: isApplicationTypeConfirmed ? 0.7 : 1,
                    "&:hover": isApplicationTypeConfirmed
                      ? {}
                      : {
                          backgroundColor:
                            selectedOption === "calendar"
                              ? "#d73a12"
                              : "#E0E0E0",
                          transform: "scale(1.02)",
                        },
                  }}
                >
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Calendar-Based
                    </Typography>
                  </CardContent>
                </Card>
              </div>
            </Grid>
            <br />

            {!isApplicationTypeConfirmed && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isApplicationTypeConfirmed}
                    disabled={!selectedOption}
                    onChange={(event) => {
                      handleApplicationTypeConfirmation(event);
                      if (event.target.checked) {
                        handleConfirmApplicationType();
                      }
                    }}
                  />
                }
                label="Confirm Irrigation management option by ticking the checkbox (this cannot be changed later once check box is ticked)"
              />
            )}

            {isApplicationTypeConfirmed && (
              <Typography
                variant="body1"
                style={{
                  marginTop: "16px",
                  fontWeight: "bold",
                  color: "#fa4616",
                }}
              >
                ✓ Selected Irrigation Type:{" "}
                {selectedOption === "soil-moisture"
                  ? "Soil Moisture-Based"
                  : selectedOption === "evapotranspiration"
                    ? "Evapotranspiration Based"
                    : "Calendar-Based"}
              </Typography>
            )}
          </>
        )}

        {selectedOption === "evapotranspiration" && (
          <>
            <p style={{ textAlign: "justify" }}>
              Recommended Resources for evapotranspiration based irrigation
              scheduling:{" "}
              <a href="https://smartirrigationapps.org/cropfit-app/">
                https://smartirrigationapps.org/cropfit-app/
              </a>
            </p>
          </>
        )}

        {selectedOption === "calendar" && (
          <p style={{ textAlign: "justify" }}>
            Recommended Resources for calendar based irrigation scheduling:{" "}
            <a href="https://smartirrigationapps.org/cropfit-app/">
              https://smartirrigationapps.org/cropfit-app/
            </a>
          </p>
        )}

        {/* Only show form and tables after both sensor and IM type are confirmed */}
        {isApplicationTypeConfirmed1 && isApplicationTypeConfirmed && (
          <>
            <div
              id="irri-mgmnt-option-tabs"
              className="tabs"
              style={{ display: "flex", flexWrap: "wrap" }}
            >
              <Tabs
                value={sectionData}
                onChange={(e, newValue) => setSectionData(newValue)}
                aria-label="Irrigation Management Options"
                variant="fullWidth"
              >
                <Tab label="Irrigation" value="v10-harvest" />
                {/* <Tab label="Planting to V10" value="planting-v10" /> */}
              </Tabs>
            </div>
            <div id="irri-mgmnt-option-tab-content" className="tab-content">
              <section data-content="v10-harvest" className="is-active">
                {/* Include the content for "Irrigation" tab */}
                <br></br>
                <Grid container spacing={2} alignItems="flex-start">
                  <Grid item xs={12} sm={3} md={2}>
                    <TextField
                      id="date-input-planting-v10"
                      label="Date"
                      variant="outlined"
                      fullWidth
                      type="date"
                      value={displayDate}
                      onChange={handleDateChange}
                      required
                      InputLabelProps={{ shrink: true, required: true }}
                      error={error}
                      helperText={error ? errorMessage : ""}
                    />
                  </Grid>
                  <Grid item xs={12} sm={9} md={10}>
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                      {/* Cards for selecting amount */}
                      <Card
                        sx={{
                          cursor: "pointer",
                          padding: "8px",
                          backgroundColor: "white",
                          marginBottom: "8px",
                          marginRight: "2px",
                          textAlign: "center",
                          fontWeight: "bold",
                        }}
                      >
                        <CardContent>
                          <Typography variant="body2">Amount</Typography>
                        </CardContent>
                      </Card>

                      {amountOptions.map((option) => (
                        <Card
                          key={option}
                          onClick={() => handleAmountCardClick(option)}
                          sx={{
                            cursor: "pointer",
                            margin: "4px",
                            padding: "10px 16px",
                            backgroundColor:
                              amount === option ? "#fa4616" : "#F5F5F5",
                            border:
                              amount === option
                                ? "2px solid rgb(255, 255, 255)"
                                : "2px solid rgb(37, 106, 185)",
                            borderRadius: "12px",
                            color: amount === option ? "white" : "#333",
                            boxShadow:
                              amount === option
                                ? "0px 4px 10px rgba(0, 0, 0, 0.2)"
                                : "none",
                            transition: "all 0.3s ease-in-out",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            height: "50px",
                            fontWeight: "bold",
                            "&:hover": {
                              backgroundColor:
                                amount === option ? "#d73a12" : "#E0E0E0",
                              transform: "scale(1.02)",
                            },
                          }}
                        >
                          <CardContent>
                            <Typography variant="body2">{option}</Typography>
                          </CardContent>
                        </Card>
                      ))}
                    </div>
                  </Grid>
                </Grid>
                <br></br>

                <Grid item xs={12}>
                  <TextField
                    id="select-planting-v10"
                    name="amount"
                    label="Amount (Inches)"
                    variant="outlined"
                    fullWidth
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    InputProps={{
                      readOnly: true,
                    }}
                    sx={{
                      "& .MuiInputBase-input": {
                        color: "rgba(0, 0, 0, 0.87)",
                        WebkitTextFillColor: "rgba(0, 0, 0, 0.87)",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    placeholder="Amount"
                    required
                  />
                </Grid>

                <div>
                  <Button
                    id="irrigation-submit"
                    variant="contained"
                    color="primary"
                    style={{ marginTop: "16px" }}
                    type="submit"
                  >
                    SUBMIT
                  </Button>
                  {formErrorMsg && (
                    <Typography variant="body2" sx={{ color: "red", mt: 1 }}>
                      {formErrorMsg}
                    </Typography>
                  )}
                  {formSuccessMsg && (
                    <Typography variant="body2" sx={{ color: "green", mt: 1 }}>
                      {formSuccessMsg}
                    </Typography>
                  )}
                </div>
              </section>

              {selectedOption === "soil-moisture" && (
                <TableContainer component={Paper}>
                  <Table
                    id="irri-mgmnt-v10-harvest-table"
                    aria-label="Irrigation Management Table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell>Sensor</TableCell>
                        <TableCell>Applied</TableCell>
                        <TableCell>
                          <EditIcon />
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {applications
                        .filter((app) => app.options === "soil-moisture")
                        .sort((a, b) => new Date(a.date) - new Date(b.date))
                        .map((app, index) => (
                          <TableRow key={app.id}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>
                              {formatDateForDisplay(app.date)}
                            </TableCell>
                            <TableCell>{app.reading}</TableCell>
                            <TableCell>{app.sensorType}</TableCell>
                            <TableCell>
                              <button
                                style={{
                                  backgroundColor:
                                    app.applied === "no" ? "red" : "green",
                                  color: "white", // Assuming you want white text for contrast
                                  border: "none", // Remove default button border styling
                                  // Add any other styling you need here
                                }}
                              >
                                {app.applied === "no" ? (
                                  <HighlightOffIcon />
                                ) : (
                                  <DoneIcon />
                                )}
                              </button>
                            </TableCell>
                            <TableCell>
                              <button>
                                {app.applied === "no" ? (
                                  <DeleteIcon
                                    onClick={() =>
                                      handleDeleteApplication(app.id)
                                    }
                                  />
                                ) : (
                                  <EditOffIcon />
                                )}
                              </button>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

              {selectedOption === "evapotranspiration" && (
                <TableContainer component={Paper}>
                  <Table
                    id="irri-mgmnt-v10-harvest-table"
                    aria-label="Irrigation Management Table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell>Sensor</TableCell>
                        <TableCell>Applied</TableCell>
                        <TableCell>
                          <EditIcon />
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {applications
                        .filter((app) => app.options === "evapotranspiration")
                        .sort((a, b) => new Date(a.date) - new Date(b.date))
                        .map((app, index) => (
                          <TableRow key={app.id}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>
                              {formatDateForDisplay(app.date)}
                            </TableCell>
                            <TableCell>{app.reading}</TableCell>
                            <TableCell>{app.sensorType}</TableCell>
                            <TableCell>
                              <button
                                style={{
                                  backgroundColor:
                                    app.applied === "no" ? "red" : "green",
                                  color: "white", // Assuming you want white text for contrast
                                  border: "none", // Remove default button border styling
                                  // Add any other styling you need here
                                }}
                              >
                                {app.applied === "no" ? (
                                  <HighlightOffIcon />
                                ) : (
                                  <DoneIcon />
                                )}
                              </button>
                            </TableCell>
                            <TableCell>
                              <button>
                                {app.applied === "no" ? (
                                  <DeleteIcon
                                    onClick={() =>
                                      handleDeleteApplication(app.id)
                                    }
                                  />
                                ) : (
                                  <EditOffIcon />
                                )}
                              </button>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

              {selectedOption === "calendar" && (
                <TableContainer component={Paper}>
                  <Table
                    id="irri-mgmnt-v10-harvest-table"
                    aria-label="Irrigation Management Table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell>Sensor</TableCell>
                        <TableCell>Applied</TableCell>
                        <TableCell>
                          <EditIcon />
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {applications
                        .filter((app) => app.options === "calendar")
                        .sort((a, b) => new Date(a.date) - new Date(b.date))
                        .map((app, index) => (
                          <TableRow key={app.id}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>
                              {formatDateForDisplay(app.date)}
                            </TableCell>
                            <TableCell>{app.reading}</TableCell>
                            <TableCell>{app.sensorType}</TableCell>
                            <TableCell>
                              <button
                                style={{
                                  backgroundColor:
                                    app.applied === "no" ? "red" : "green",
                                  color: "white", // Assuming you want white text for contrast
                                  border: "none", // Remove default button border styling
                                  // Add any other styling you need here
                                }}
                              >
                                {app.applied === "no" ? (
                                  <HighlightOffIcon />
                                ) : (
                                  <DoneIcon />
                                )}
                              </button>
                            </TableCell>
                            <TableCell>
                              <button>
                                {app.applied === "no" ? (
                                  <DeleteIcon
                                    onClick={() =>
                                      handleDeleteApplication(app.id)
                                    }
                                  />
                                ) : (
                                  <EditOffIcon />
                                )}
                              </button>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </div>
          </>
        )}
      </form>
    </Container>
  );
}

export default CottonIrrigationManagementForm;
